import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { SuguyakuChangePasswordSentComponent } from './suguyaku-change-password-sent/suguyaku-change-password-sent.component';
import { SuguyakuForgotPasswordComponent } from './suguyaku-forgot-password/suguyaku-forgot-password.component';
import { SuguyakuInputComponent } from './suguyaku-input/suguyaku-input.component';
import { SuguyakuLoginComponent } from './suguyaku-login/suguyaku-login.component';
import { SuguyakuOemHeaderComponent } from './suguyaku-oem-header/suguyaku-oem-header.component';
import { SuguyakuOemLoginMessageComponent } from './suguyaku-oem-login-message/suguyaku-oem-login-message.component';
import { SuguyakuOemRegisterMessageComponent } from './suguyaku-oem-register-message/suguyaku-oem-register-message.component';
import { SuguyakuPasswordInputComponent } from './suguyaku-password-input/suguyaku-password-input.component';
import { SuguyakuRegisterResendComponent } from './suguyaku-register-resend/suguyaku-register-resend.component';
import { SuguyakuRegisterSendComponent } from './suguyaku-register-send/suguyaku-register-send.component';
import { SuguyakuRegisterComponent } from './suguyaku-register/suguyaku-register.component';
import { SuguyakuResetPasswordComponent } from './suguyaku-reset-password/suguyaku-reset-password.component';
import { SuguyakuUnblockComponent } from './suguyaku-unblock/suguyaku-unblock.component';
import { SuguyakuComponent } from './suguyaku/suguyaku.component';

@NgModule({
  declarations: [
    SuguyakuComponent,
    SuguyakuLoginComponent,
    SuguyakuRegisterComponent,
    SuguyakuUnblockComponent,
    SuguyakuRegisterResendComponent,
    SuguyakuRegisterSendComponent,
    SuguyakuForgotPasswordComponent,
    SuguyakuResetPasswordComponent,
    SuguyakuChangePasswordSentComponent,
    SuguyakuInputComponent,
    SuguyakuPasswordInputComponent,
    SuguyakuOemHeaderComponent,
    SuguyakuOemRegisterMessageComponent,
    SuguyakuOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SuguyakuResetPasswordComponent,
    SuguyakuComponent,
    SuguyakuRegisterResendComponent,
    SuguyakuRegisterSendComponent,
    SuguyakuUnblockComponent,
    SuguyakuChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SuguyakuModule { }
